function getRowNumber(index, meta) {
  if (!meta) return index + 1;
  return (meta.current_page - 1) * meta.limit + (index + 1);
}

export default getRowNumber;
